import {useQueries} from '@tanstack/react-query'
import {getSubCategoryList} from '@/services/SubCategoryService/subCategory'

// dropdowns/sub_categories returns { data: [{ id, en }] }
export const useSubCategoryList = (isEnabled = true) => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['SUB_CATEGORY_LIST'],
        queryFn: getSubCategoryList,
        enabled: isEnabled,
      },
    ],
  })

  const response = results?.[0]?.data
  const subCategoryListData = response?.data ?? []

  return {
    subCategoryListData,
    isLoading: results?.[0]?.isLoading || false,
  }
} 